__turbopack_context__.v({
  "button": "ThemeToggle-module__PeqOfa__button",
  "icon": "ThemeToggle-module__PeqOfa__icon",
});
